import { useContext, useEffect } from "react";

import axios from "axios";

import useToast from "@hooks/useToast";
import { useNavigate } from "react-router-dom";

import ActiveYearContext from "@context/ActiveYearContext";
import SchoolContext from "@context/SchoolContext";

const finance_api = 'https://finance.otgontenger.edu.mn/api'

function getCookie(name) {
	let cookieValue = null;

	if (document.cookie && document.cookie !== "") {
		const cookies = document.cookie.split(";");
		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i].trim();

			// Does this cookie string begin with the name we want?
			if (cookie.substring(0, name.length + 1) === name + "=") {
				cookieValue = decodeURIComponent(
					cookie.substring(name.length + 1)
				);
				break;
			}
		}
	}
	return cookieValue;
}

/**
 * @param {boolean} isDisplay Toast гаргах эсэх
 */
function useApi(isDisplay = false) {
	// Toast нэмэх функц
	const addToast = useToast();

	const navigate = useNavigate();

	// Хуудас шилжихэд өмнөх хүсэлтийг зогсоох
	const controller = new AbortController();

	const { cyear_name, cseason_id } = useContext(ActiveYearContext);
	const { school_id } = useContext(SchoolContext);

	const source = axios.CancelToken.source();
	const instance = axios.create({
		baseURL: process.env.REACT_APP_SERVER_URL,
		withCredentials: true, // Хүсэлт болгонд ээр cookie явуулах нь
		cancelToken: source.token,
		signal: controller.signal,
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
		},
	});

	instance.defaults.headers.put["X-CSRFToken"] = getCookie("csrftoken");
	instance.defaults.headers.post["X-CSRFToken"] = getCookie("csrftoken");
	instance.defaults.headers.delete["X-CSRFToken"] = getCookie("csrftoken");

	const instance1 = axios.create({
		baseURL: process.env.REACT_APP_SERVER_URL,
		withCredentials: true, // Хүсэлт болгонд ээр cookie явуулах нь
		cancelToken: source.token,
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "multipart/form-data",
		},
	});
	instance1.defaults.headers.put["X-CSRFToken"] = getCookie("csrftoken");
	instance1.defaults.headers.post["X-CSRFToken"] = getCookie("csrftoken");
	instance1.defaults.headers.delete["X-CSRFToken"] = getCookie("csrftoken");

	const hr_instance = axios.create({
		baseURL: process.env.REACT_APP_MUIS_HR_URL,
		withCredentials: true, // Хүсэлт болгонд ээр cookie явуулах нь
		cancelToken: source.token,
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "multipart/form-data",
		},
	});
	hr_instance.defaults.headers.put["X-CSRFToken"] = getCookie("csrftoken");
	hr_instance.defaults.headers.post["X-CSRFToken"] = getCookie("csrftoken");
	hr_instance.defaults.headers.delete["X-CSRFToken"] = getCookie("csrftoken");
	/*
		HR response
	*/

	hr_instance.interceptors.response.use(
		function (rsp) {
			const data = rsp?.data;
			const text = data?.info;

			if (data.code === "INF_017") {
				type = "warning";
				addToast({
					type: type,
					text: text,
					time: 10000,
				});
			}

			// хүсэлт амжилттай болоод info ирэх үед
			else if (data?.success && text) {
				var type = "success";
				if (!isDisplay) {
					if (data.code === "INF_007") {
						type = "warning";
					}

					addToast({
						type: type,
						text: text,
					});
				}
			} else if (!data?.success) {
				// Toast дээр error харуулах
				const err_message = data.error;
				if (!isDisplay) {
					var type = "error";
					if (data.code === "ERR_007") {
						type = "warning";
					}
					addToast({
						type: type,
						text: err_message,
					});
				}
			}

			return data;
		},

		function (error) {
			// axios huseltiig abort hiisen uyd uildel hiihgv
			if (error.message === "canceled") {
				return { success: false };
			}

			if (error.message === "Network Error") {
				return { success: false };
			}

			var err = error?.response?.data;
			var status_code = error?.response?.status;

			if ([401, 403].indexOf(status_code) !== -1) {
				navigate("/login");
			} else {
				if (!isDisplay) {
					addToast({
						type: "error",
						text:
							err?.message ||
							"Алдаа гарлаа. Системийн админд хандана уу.",
					});
				}
			}

			return Promise.reject(err);
		}
	);

	/*
        Response дата
    */
	instance.interceptors.response.use(
		function (rsp) {
			const data = rsp?.data;
			const text = data?.info;

			if (data.code === "INF_017") {
				type = "warning";
				addToast({
					type: type,
					text: text,
					time: 10000,
				});
			}

			// хүсэлт амжилттай болоод info ирэх үед
			else if (data?.success && text) {
				var type = "success";
				if (!isDisplay) {
					if (data.code === "INF_007") {
						type = "warning";
					}

					addToast({
						type: type,
						text: text,
					});
				}
			} else if (!data?.success && data.error && typeof data.error === 'string') {
				// Toast дээр error харуулах
				const err_message = data.error;
				if (!isDisplay) {
					var type = "error";
					if (data.code === "ERR_007") {
						type = "warning";
					}
					addToast({
						type: type,
						text: err_message,
					});
				}
			}

			return data;
		},
		function (error) {
			// axios huseltiig abort hiisen uyd uildel hiihgv
			if (error.message === "canceled") {
				return { success: false };
			}

			if (error.message === "Network Error") {
				return { success: false };
			}

			var err = error?.response?.data;
			var status_code = error?.response?.status;

			if ([401, 403].indexOf(status_code) !== -1) {
				navigate("/login");
			} else {
				if (!isDisplay) {
					addToast({
						type: "error",
						text:
							err?.message ||
							"Алдаа гарлаа. Системийн админд хандана уу.",
					});
				}
			}

			return Promise.reject(err);
		}
	);

	/*
        Response 1  дата
    */
		instance1.interceptors.response.use(
			function (rsp) {
				const data = rsp?.data;
				const text = data?.info;

				if (data.code === "INF_017") {
					type = "warning";
					addToast({
						type: type,
						text: text,
						time: 10000,
					});
				}

				// хүсэлт амжилттай болоод info ирэх үед
				else if (data?.success && text) {
					var type = "success";
					if (!isDisplay) {
						if (data.code === "INF_007") {
							type = "warning";
						}

						addToast({
							type: type,
							text: text,
						});
					}
				} else if (!data?.success) {
					// Toast дээр error харуулах
					const err_message = data.error;
					if (!isDisplay) {
						var type = "error";
						if (data.code === "ERR_007") {
							type = "warning";
						}
						addToast({
							type: type,
							text: err_message,
						});
					}
				}

				return data;
			},

			function (error) {
				// axios huseltiig abort hiisen uyd uildel hiihgv
				if (error.message === "canceled") {
					return { success: false };
				}

				if (error.message === "Network Error") {
					return { success: false };
				}

				var err = error?.response?.data;
				var status_code = error?.response?.status;

				if ([401, 403].indexOf(status_code) !== -1) {
					navigate("/login");
				} else {
					if (!isDisplay) {
						addToast({
							type: "error",
							text:
								err?.message ||
								"Алдаа гарлаа. Системийн админд хандана уу.",
						});
					}
				}

				return Promise.reject(err);
			}
		);

	useEffect(() => {
		return () => {
			controller.abort();
		};
	}, []);

	return {
		source,
		instance,

		//  Хэрэглэгчийн мэдээлэл
		user: {
			logged: () => instance.get("/user/logged/"),
			login: (data) => instance.post(`/user/login/`, data),
			logout: () => instance.get(`/user/logout/`),
			firstCheckLogged: () => instance.get("user/first_logged/"),
			changepass: (pk, data) => instance.put(`/user/change_pass/${pk}/`, data),
			forgotPassword: (data) => instance.post(`/user/forgot-password`, data)
		},
		teacher: {
			get: () => instance.get(`/teacher/info/`),
			getOne: (pk) => instance.get(`/teacher/info/${pk}/`),
			put: (data, pk) => instance.put(`/teacher/info/${pk}/`, data),

			settings: {
				get: (limit='Бүгд', page=1, sort='', search='') => instance.get(`/teacher/settings/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}`),
				post: (data) => instance.post(`/teacher/settings/`, data),
				put: (data, id) => instance.put(`/teacher/settings/${id}/`, data),
				delete: (id) => instance.delete(`/teacher/settings/${id}/`),
				postFile:(id,file) => instance.post(`/teacher/settings/file/${id}/`, file),
				deleteFile:(id) => instance.delete(`/teacher/settings/file/${id}/`),
				approve: () => instance.get('/teacher/settings/file/')
			},

			category: {
				get: (limit='Бүгд', page=1, sort='', search='') => instance.get(`/teacher/category/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}`),
				post: (data) => instance.post(`/teacher/category/`, data),
				put: (data, id) => instance.put(`/teacher/category/${id}/`, data),
				delete: (id) => instance.delete(`/teacher/category/${id}/`),
			},

			createLesson: {
				get: (lesson='', week='') => instance.get(`/teacher/lesson/times/?lesson=${lesson}&week=${week}`),
				post: (data) => instance.post(`/teacher/lesson/times/`, data),
				put: (data, id) => instance.put(`/teacher/lesson/times/${id}/`, data),
				delete: (pk) => instance.delete(`/teacher/lesson/times/${pk}/`),
			},

			/** Бүтээл */
			research: {
				invention: {
					// get: (limit, page, sort, search,) => instance.get(`/teacher/research/invention/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}`),
					get: () => instance.get(`/teacher/research/invention/`),

					getOne: (pk) => instance.get(`/teacher/research/invention/${pk}/`),
					put: (data, pk ) => instance.put(`/teacher/research/invention/${pk}/`, data),

					post: (data) =>
						instance1.post(`/teacher/research/invention/`, data),
					delete: (pk) =>
						instance.delete(`/teacher/research/invention/${pk}/`),
					category: {
						getList: () =>
							instance.get(`/teacher/research/invention/list`),
					},
					size: {
						getList: () =>
							instance.get(
								`/teacher/research/invention/size/list`
							),
					},
				},
				paper: {
					get: () => instance.get(`/teacher/research/paper/`),
					getOne: (pk) => instance.get(`/teacher/research/paper/${pk}/`),
					post: (data) =>
						instance.post(`/teacher/research/paper/`, data),
					put: (data, pk) =>
						instance.put(`/teacher/research/paper/${pk}/`, data),
					delete: (pk) =>
						instance.delete(`/teacher/research/paper/${pk}/`),
					category: {
						getList: () =>
							instance.get(
								`/teacher/research/paper/category/list`
							),
					},
				},
				note: {
					get: () => instance.get(`/teacher/research/note/`),
					getOne: (pk) => instance.get(`/teacher/research/note/${pk}/`),
					put: (data, pk) => instance.put(`/teacher/research/note/${pk}/`, data),
					post: (data) =>
						instance1.post(`/teacher/research/note/`, data),
					delete: (pk) =>
						instance.delete(`/teacher/research/note/${pk}/`),
					country: {
						getList: () =>
							instance.get(`/teacher/research/note/country/list`),
					},
					category: {
						getList: () =>
							instance.get(
								`/teacher/research/note/category/list`
							)
					}
				},
				quotation: {
					get: () => instance.get(`/teacher/research/quotation/`),
					getOne: (pk) => instance.get(`/teacher/research/quotation/${pk}/`),
					post: (data) =>
						instance1.post(`/teacher/research/quotation/`, data),
					put: (data, pk) =>
						instance.put(`/teacher/research/quotation/${pk}/`, data),
					delete: (pk) =>
						instance.delete(`/teacher/research/quotation/${pk}/`),
					category: {
						getList: () =>
							instance.get(
								`/teacher/research/quotation/category/list`
							),
					},
				},

			},

			// Төсөл
			project: {
				project: {
					get: () => instance.get(`/teacher/project/project/`),
					getOne: (pk) => instance.get(`/teacher/project/project/${pk}/`),

					post: (data) =>
						instance1.post(`/teacher/project/project/`, data),
					put: (data, pk) =>
						instance.put(`/teacher/project/project/${pk}/`, data),

					delete: (pk) =>
						instance.delete(`/teacher/project/project/${pk}/`),
					category: {
						getList: () =>
							instance.get(
								`/teacher/project/project/category/list`
							),
					},
					// subCategory: {
					// 	getList: (pk) =>
					// 		instance.get(
					// 			`/teacher/project/project/subcategory/list/${pk}`
					// 		),
					// },
					// fieldOfScience: {
					// 	getList: () =>
					// 		instance.get(
					// 			`/teacher/project/project/fieldofscience/list`
					// 		),
					// },
					// subFieldOfScience: {
					// 	getList: (pk) =>
					// 		instance.get(
					// 			`/teacher/project/project/subfieldofscience/list/${pk}`
					// 		),
					// },
					// client: {
					// 	getList: () =>
					// 		instance.get(
					// 			`/teacher/project/project/client/list`
					// 		),
					// },
					// financeSource: {
					// 	getList: () =>
					// 		instance.get(
					// 			`/teacher/project/project/financesource/list`
					// 		),
					// },
					// stateOfProject: {
					// 	getList: () =>
					// 		instance.get(
					// 			`/teacher/project/project/stateofproject/list`
					// 		),
					// },
					school: {
						getList: () =>
							instance.get(
								`/teacher/project/project/school/list`
							),
					},
				},

				contractwork: {
					get: () => instance.get(`/teacher/project/contract-work/`),
					getOne: (pk) => instance.get(`/teacher/project/contract-work/${pk}/`),
					post: (data) =>
						instance1.post(`/teacher/project/contract-work/`, data),
					put: (data, pk) =>
						instance.put(`/teacher/project/contract-work/${pk}/`, data),
					delete: (pk) =>
						instance.delete(`/teacher/project/contract-work/${pk}/`),
				},

			},

			// Зөвлөх багшийн ангийн оюутнууд
			student: {
				get: (page, limit, sort, search, user_id, checked, group) => instance.get(`/teacher/student/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&teacher=${user_id}&year=${cyear_name}&season=${cseason_id}&checked=${checked}&group=${group}`),
				getStudentOne: (pk) => instance.get(`/teacher/student/info/all/${pk}/?year=${cyear_name}&season=${cseason_id}`),
				getGroups: (page,limit,search,user_id) => instance.get(`/teacher/groups/?page=${page}&limit=${limit}&search=${search}&teacher=${user_id}`),
				download: (group_id) =>  instance.get(`/teacher/groups/download/?group=${group_id}`)
			},

			intellectual: {
				patent: {
					get: (search) => instance.get(`/teacher/intellectual/patent/?search=${search}`),
					getOne: (pk) => instance.get(`/teacher/intellectual/patent/${pk}/`),
					post: (data) =>
						instance1.post(`/teacher/intellectual/patent/`, data),
					put: (data, pk) =>
						instance.put(`/teacher/intellectual/patent/${pk}/`, data),
					delete: (pk) =>
						instance.delete(`/teacher/intellectual/patent/${pk}/`),
				},
				model_patent: {
					getOne: (pk) =>
						instance.get(`/teacher/intellectual/model-patent/${pk}/`),
					put: (data, pk) =>
						instance.put(
							`/teacher/intellectual/model-patent/${pk}/`, data),
					get: (search) =>
						instance.get(`/teacher/intellectual/model-patent/?search=${search}`),
					post: (data) =>
						instance1.post(
							`/teacher/intellectual/model-patent/`,
							data
						),
					delete: (pk) =>instance.delete(`/teacher/intellectual/model-patent/${pk}/`),
				},
				symbol_cert: {
					get: (search) =>
						instance.get(`/teacher/intellectual/symbol-cert/?search=${search}`),
					post: (data) =>
						instance1.post(
							`/teacher/intellectual/symbol-cert/`,
							data
						),
				},
				license_cert: {
					get: (search) =>
						instance.get(`/teacher/intellectual/license-cert/?search=${search}`),
					post: (data) =>
						instance1.post(
							`/teacher/intellectual/license-cert/`,
							data
						),
				},
				right_cert: {
					get: (search) =>
						instance.get(`/teacher/intellectual/right-cert/?search=${search}`),
					post: (data) =>
						instance1.post(
							`/teacher/intellectual/right-cert/`,
							data
						),
				},
				research_field: {
					get: () =>
						instance.get(`/teacher/intellectual/research-field/`),
					post: (data) =>
						instance1.post(
							`/teacher/intellectual/research-field/`,
							data
						),
					put: (data) =>
						instance1.post(
							`/teacher/intellectual/research-field/`,
							data
						),
				},
			},

			/** Дотуур байр */
			dormitory: {
				/** Хүсэлт */
				get: (teacher = "") =>
					instance.get(`/teacher/dormitory/?teacher=${teacher}`),

				getOne: (pk) => instance.get(`/teacher/dormitory/${pk}/`),
				post: (data) => instance.post(`/teacher/dormitory/`, data),
				put: (data, pk) =>
					instance.put(`/teacher/dormitory/${pk}/`, data),

				/** Өрөөний төрөл */
				type: {
					get: () => instance.get(`/teacher/dormitory/type/`),
				},

				/** Өрөө */
				room: {
					get: (room_type, gender="") =>
						instance.get(
							`/teacher/dormitory/room/${room_type}/?gender=${gender}`
						),
				},
				request: {
					/** Хүсэлт */
					getOne: (pk) => instance.get(`/teacher/dormitory/request/${pk}/`),
					post: data => instance.post(`/teacher/dormitory/request/`, data),
					put: (data, pk) => instance.put(`/teacher/dormitory/request/${pk}/`, data),
				},
			},

			/** Дүнгийн мэдээлэл */
			scoreregister: {
				get: (page, limit, sort, search, lesson, group, scoretype, lesson_type, year, season) => {
					return (
						instance.get(
							`/teacher/scoreregister/?page=${page}&limit=${limit}&sorting=${sort}&year=${year}&season=${season}&lesson=${lesson}&group=${group}&scoretype=${scoretype}&search=${search}&lesson_type=${lesson_type}`
						)
					)
				},
				getNoLimit: (lesson, group, scoretype, search) => {
					return (
						instance.get(
							`/teacher/scoreregister/print/?lesson=${lesson}&group=${group}&scoretype=${scoretype}&search=${search}`
						)
					)
				},
				getLesson: (type='',  lesson_year, lesson_season) =>
					instance.get(
						`/teacher/lesson/list/?stype=${type}&lesson_year=${lesson_year}&lesson_season=${lesson_season}`
					),
				getTimeLesson: (lesson_year, lesson_season) =>
					instance.get(
						`/teacher/lesson/time-list/?lesson_year=${lesson_year}&lesson_season=${lesson_season}`
					),
				getGroup: (lesson) =>
					instance.get(
						`/teacher/group/list/?year=${cyear_name}&season=${cseason_id}&lesson=${lesson}`
					),

				put: (id, data) =>
					instance.put(
						`/teacher/scoreregister/${id}/?year=${cyear_name}&season=${cseason_id}`,
						data
					),
				putLetterGrade:(id,data,lesson)=>instance.put(`/teacher/scoreregister/lettergrade/${id}/?year=${cyear_name}&season=${cseason_id}&lesson=${lesson}`,data),
				// // File excel шалгах
				post: (data) =>
					instance.post(
						`/teacher/scoreregister/?year=${cyear_name}&season=${cseason_id}`,
						data
					),

				// Файл оруулсан датаг бааз руу хадгалах
				postImportData: (data) =>
					instance.post(
						`/teacher/scoreregister/import/?year=${cyear_name}&season=${cseason_id}`,
						data
					),

				getUrl: () =>
					instance.get(`/teacher/score-template/`),

				getScoreType: (code, type='') =>
					instance.get(`/teacher/scoretype/${code}/?year=${cyear_name}&season=${cseason_id}&school=${school_id}&type=${type}`),

				postScoreType: (code, data, elearn=false) =>
					instance.post(
						`/teacher/scoretype/${code}/?year=${cyear_name}&season=${cseason_id}&school=${school_id}&elearn=${elearn}`,
						data
				),

				checkTime : (stype) =>
					instance.get(`/teacher/scoretype/check-time/?type=${stype}`),

				getType: () =>
					instance.get(`/teacher/scoretype/list/`),
				postNewScoreType: (data) =>
					instance.post(`/teacher/scoretype/list/`, data),
				deleteType: (id) =>
					instance.delete(`/teacher/scoretype/list/${id}/`),
				postApprove: (data) =>
					instance.post(`/teacher/scoretype/approve/`, data),
			},

			schedule: {
				get: (start,end, month) =>
					instance.get(
						`/teacher/schedule/?year=${cyear_name}&season=${cseason_id}&start=${start}&end=${end}&month=${month}`
					),

				qr: (body) =>
					instance.post(
						`/teacher/schedule-qr/`, body
					),
				getList: () =>
					instance.get(
						`/teacher/schedule/list/`
					)
			},

			/** Цалингийн мэдээлэл */
			salaryestimate: {
				get: (limit, page, sort, search, school, subSchools, department, year, month, type, employee='') =>
					instance.get(`${finance_api}/salary/salary-pre-calculate/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&school=${school}&subSchools=${subSchools}&department=${department}&year=${year}&month=${month}&type=${type}&employee=${employee}`),
			},

			/** Багшийн хөрөнгө эзэмшил */
			stock: {
				get: () =>
					instance.get(`/teacher/stock/`)
			},

			// Өргөдөл хүсэлт
			complaint: {
				leave: {
					get: (limit, page, sort, search, menu_id, leave_type_id) =>
						instance.get(
							`/teacher/request/leave/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&menu=${menu_id}&leave_type_id=${leave_type_id}`
						),
					post: (data, menu_id) =>
						instance.post(
							`/teacher/request/leaveanswer/?menu=${menu_id}`,
							data
						),
					getOne: (pk, menu_id) =>
						instance.get(
							`/teacher/request/leave/${pk}/?menu=${menu_id}`
						),
				},

				correspond: {
					get: (limit, page, sort, search, menu, solved) =>
						instance.get(
							`/teacher/request/correspond/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&menu=${menu}&solved=${solved}`
						),
					postAnswer: (data, menu) =>
						instance.post(
							`/teacher/request/correspond/answer/?menu=${menu}`,
							data
						),
				},

				routing: {
					get: (limit, page, sort, search, menu_id, type_id) =>
						instance.get(
							`/teacher/request/routing/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&menu=${menu_id}&type=${type_id}`
						),
					post: (data, menu_id) =>
						instance.post(
							`/teacher/request/routing/answer/?menu=${menu_id}`,
							data
						),
					getOne: (pk, menu_id) =>
						instance.get(
							`/teacher/request/routing/${pk}/?menu=${menu_id}`
						),
				},
			},

			/** санал болгох төлөвлөгөө */
			learningplan: {
				get: (student_id) =>
					instance.get(
						`/student/plan/${student_id}/?student_id=${student_id}&year=${cyear_name}&season=${cseason_id}`
					),
			},
			/** Шалгалтын хуваарь */
			examtimetable: {
				get: () =>
					instance.get(
						`/teacher/examtimetable/?year=${cyear_name}&season=${cseason_id}`
					),
			},
			/** Хувийн мэдээлэл */
			information: {
				get: (teacher_id) =>
					instance.get(
						`/teacher/personal-information/${teacher_id}/`
					),
				put: (data, teacher_id) =>
					instance.put(
						`/teacher/personal-information/${teacher_id}/`,
						data
					),

				address: {
					get: (teacher_id) =>
						instance.get(`/teacher/address/${teacher_id}/`),
					post: (data, teacher_id) =>
						instance.post(`/teacher/address/${teacher_id}/`, data),
				},
				family: {
					get: (teacher_id) =>
						instance.get(`/teacher/family/${teacher_id}/`),
					post: (data) => instance.post(`/teacher/family/`, data),
					put: (data, pk, teacher) =>
						instance.put(`/teacher/family/${teacher}/${pk}/`, data),
					delete: (teacher, pk) =>
						instance.delete(`/teacher/family/${teacher}/${pk}/`),
				},
				education: {
					get: (teacher_id) =>
						instance.get(`/teacher/education/${teacher_id}/`),
				},
			},

			/** Цалингийн дэлгэрэнгүй */
			paymentdetail: {
				get: (teacher_id) =>
					instance.get(`/teacher/paymentdetail/${teacher_id}/`),
				getTransiction: (student_id) =>
					instance.get(
						`/teacher/paymentdetail/transiction/${teacher_id}/`
					),
			},

			// Үзэж байгаа хичээлийн хуваарь
			lesson: {

				studentlist:{
					get: (lesson, assignment='') =>
						instance.get(
							`/teacher/lesson/studentlist/?lesson=${lesson}&lesson_year=${cyear_name}&lesson_season=${cseason_id}&assignment=${assignment}`
						),

					// Багшийн тухайн хичээлийг үзэж байгаа оюутнуудын жагсаалт
					getList: (lesson) => instance.get(`/teacher/lesson/student/list/?lesson=${lesson}`),
				},

				studentHomeWork: {
					/** Тухайн даалгаврын хариултууд */
					getStudentHomework: (student, assignment) =>
						instance.get(
							`/teacher/lesson/homework/?student=${student}&assignment=${assignment}`
						),
					put: (pk, data) =>
						instance.put(
							`/teacher/lesson/homework/${pk}/`, data
						),

					multiplePut: (data) =>
						instance.put(
							`/teacher/lesson/assignment/score/`, data
						),
				},

				get: (page, limit, sort, search, stype = "one") =>
					instance.get(
						`/teacher/lesson/list/?year=${cyear_name}&season=${cseason_id}&page=${page}&sorting=${sort}&limit=${limit}&search=${search}&stype=${stype}`
					),
				getChallenge: (page, limit, search, teacher_id, stype = "one") => instance.get(`/teacher/lesson/list/challenge/?year=${cyear_name}&season=${cseason_id}&page=${page}&limit=${limit}&search=${search}&teacher_id=${teacher_id}&stype=${stype}`),
				getLessonTopics: (page, limit, lesson_id) => instance.get(`/teacher/lesson/list/challenge/topics/?page=${page}&limit=${limit}&lesson_id=${lesson_id}`),
				getId: (question_id) => instance.get(`/teacher/lesson/list/challenge/topics/id/?lesson_id=${question_id}`),

				getOne: (lessonId) =>
					instance.get(`/teacher/lesson/getone/${lessonId}/`),

				/* Тухайн тэнхимийн бүх хичээлийг авах */
				getAll: (teacherId) =>
					instance.get(`/teacher/lesson/getall/?teacher=${teacherId}`),

				getKreditZadargaa: (lessonId) =>
					instance.get(`/teacher/lesson/kredit/${lessonId}/`),

				getMaterials: (lessonId, type='', weekId='') =>
					instance.get(`/teacher/lesson/material/${lessonId}/?lesson_type=${type}&week=${weekId}`),

				postSedev: (lessonId, data) =>
					instance.post(`/teacher/lesson/sedev/${lessonId}/`, data),

				getSedev: (lessonId) =>
					instance.get(`/teacher/lesson/sedev/${lessonId}/`),

				postMaterialFile: (lessonId, data) =>
					instance.post(`/teacher/lesson/material/${lessonId}/`, data),

				editMaterial: (id, data) =>
					instance.put(`/teacher/lesson/material/${id}/`, data),

				postGeneralMaterial: (lessonId, data) =>
					instance.post(`/teacher/lesson/material/general/${lessonId}/`, data),

				postAssignmentMaterial: (lessonId, data) =>
					instance.post(`/teacher/lesson/material/assignment/${lessonId}/`, data),

				getAssignmentMaterial: (lessonId) =>
					instance.get(`/teacher/lesson/material/assignment/${lessonId}/`),

				postEditorImage: (lessonId, data) =>
					instance.post(`/teacher/lesson/editor/image/${lessonId}/`, data),

				deleteMaterial: (id) =>
					instance.delete(`/teacher/lesson/material/${id}/`),

				postLessonImage: (id, data) =>
					instance.post(`/teacher/lesson/image/${id}/`, data),

				getSedevAll: (lessonId) =>
					instance.get(`/teacher/lesson/sedev/${lessonId}/`),

				sendMaterial: (lessonId, data) => instance.post(`/teacher/lesson/material/send-material/${lessonId}/`, data),

				getLekts: (lessonId) => instance.get(`/teacher/lesson/material/send-material/${lessonId}/`),

				// ХБА хичээлийн лекц батлуулах хүсэлт
				getApproveMaterial: (page, limit, sort, search, type, teacherId, lessonId) =>
					instance.get(`teacher/lesson/approve/?page=${page}&limit=${limit}&type=${type}&sorting=${sort}&search=${search}&teacher=${teacherId}&lesson=${lessonId}`),

				postAnswer: (data) =>
					instance.post(`teacher/lesson/approve/`, data),

				title: (lesson) => instance.get(`teacher/lesson/sedev/group/?lesson=${lesson}&year=${cyear_name}&season=${cseason_id}`),
				postGroup: (data) => instance.post(`teacher/lesson/sedev/group/?year=${cyear_name}&season=${cseason_id}`, data),
				deleteGroup: (id) => instance.delete(`teacher/lesson/sedev/group/${id}/?year=${cyear_name}&season=${cseason_id}`)
			},

			/** Тодорхойлолт */
			definition: {
				get: (code, type) =>
					instance.get(
						`/student/definition/?definition_type=${type}&code=${code}`
					),
				getYear: (code) =>
					instance.get(
						`/student/definition/season/option?code=${code}`
					),
				getSum: (data, code) =>
					instance.post(`student/definition/sum/?code=${code}`, data),
				getCheck: (data) =>
					instance.post(`student/definition/check/`, data),
			},
			/* Анги бүлгийн бүртгэл */
			group:{
				getList: (departId, degree, profession, joined_year) => {
					var degree_id = ''
					var profession_id = ''
					var join_year = ''
					var depart_id = ''
					if (departId) depart_id = departId
					if (degree ) degree_id = degree
					if (profession ) profession_id = profession
					if (joined_year ) join_year = joined_year
					return instance.get(`/core/teacher/group/list/?department=${depart_id}&degree=${degree_id}&profession=${profession_id}&join_year=${join_year}&schoolId=${school_id}`)
				},
				getEditList: (pk) => instance.get(`/teacher/group/list/${pk}/`),
				get: (limit, page, sort, search, only_study, department, degree, profession, join_year) => instance.get(`/teacher/group/${only_study}/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&salbar=${department}&degree=${degree}&profession=${profession}&join=${join_year}&school=${school_id}`),
				post: data => instance.post('/teacher/group/', data),
				getOne: (pk) => instance.get(`/teacher/group/one/${pk}/`),
				put: (data, pk) => instance.put(`/teacher/group/one/${pk}/`, data),
				delete: (pk) => instance.delete(`/teacher/group/one/${pk}/`),

				getTimetableList: (lesson) => instance.get(`/teacher/timetable/${lesson}/`),

				/** Багшаас хамаарах ангийн жагсаалт */
				getGroup: (teacher) => instance.get(`/teacher/group/class/?teacher=${teacher}`),

				/** Бүх сургуулийн анги */
				getAllList: (profession) => {
					var profession_id = ''
					if (profession ) profession_id = profession
					return instance.get(`/student/group/list/?profession=${profession_id}`)
				}
			},
		},
		surgalt: {
			getPlan: (student) =>
				instance.get(`/surgalt/learningplan/${student}`),

			getPlanFromProfession: (profession) =>
				instance.get(
					`/teacher/learning/plan/?profession=${profession}&school=${school_id}`
				),
			getWeek:(lesson,type) =>
				instance.get(`/surgalt/learning/week/?lesson=${lesson}&lesson_year=${cyear_name}&lesson_season=${cseason_id}&type=${type}`),
			/** Хичээлийн стандарт */
			lessonStandart: {
				getList: (dep_id) => {
					if (dep_id === undefined)
						dep_id=''
					return instance.get(`/surgalt/lessonstandart/list/?school=${school_id}&department=${dep_id}`)
				},

				// Хичээлийн хуваарьт зориулж хичээлийн лист авах
				getTimetableList: () => {
					return instance.get(`/surgalt/lessonstandart/timetable-list/?school=${school_id}&lesson_year=${cyear_name}&lesson_season=${cseason_id}`)
				},

				getListAll: () => instance.get(`/surgalt/lessonstandart/list/`),
				get: (limit, page, sort, search, dep_id, category_id) => instance.get(`/surgalt/lessonstandart/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&department=${dep_id}&category=${category_id}&schoolId=${school_id}`),
				post: data => instance.post('/surgalt/lessonstandart/', data),
				put: (data, pk) => instance.put(`/surgalt/lessonstandart/${pk}/`, data),
				getOne: (pk) => instance.get(`/surgalt/lessonstandart/${pk}/`),
				delete: (pk) => instance.delete(`/surgalt/lessonstandart/${pk}/`),
				getStudentLesson: (selected_student) => {
					return instance.get(`/surgalt/lessonstandart/student/list/?student=${selected_student}`)
				},
				getType: (pk) => instance.get(`/surgalt/lessonstandart/type/${pk}/`),
			}
		},
		activeyear: {
			get: () => instance.get(`/lms/activeyear/`),
		},
		/** Сургалтын хуанли харуулах api */
		calendar: {
			get: () => instance.get(`/teacher/study-calendar/`),
		},

		qpay: {
			create: (student, datas) => instance.post(`/teacher/qpay/create/${student}/`, datas),
			check: (payment, close) => instance.get(`/teacher/qpay/check-pay/${payment}/?close=${close}`),
			exit: (payment) => instance.get(`/teacher/qpay/exit/?payment=${payment}`),
		},

		hrms: {
			/** Улс */
			country: {
				get: () => instance.get(`/core/country/`),
				getOne: (pk) => instance.get(`/core/country/${pk}/`),
			},
			/** Аймаг */
			unit1: {
				get: () => instance.get(`/core/aimaghot/`),
				getOne: (pk) => instance.get(`/core/aimaghot/${pk}/`),
			},
			/** Сум */
			unit2: {
				get: (unit1) => instance.get(`/core/sumduureg/${unit1}/`),
				getOne: (pk) => instance.get(`/core/sumduureg/${pk}/`),
			},
			/** Баг */
			unit3: {
				get: (unit2) => instance.get(`/core/baghoroo/${unit2}/`),
				getOne: (pk) => instance.get(`/core/baghoroo/${pk}/`),
			},
			/** Хөтөлбөрийн баг */
			department: {
				get: () => instance.get(`/core/department/?school=${school_id}`),
				getSelectSchool: (school) => instance.get(`/core/department/?school=${school}`),
				getRegister: () => instance.get(`/core/department/register/?school=${school_id}`),
				getOne: (pk) => instance.get(`/core/department/${pk}/`),
				getTeachers: (pk) => instance.get(`/core/department/teacher/${pk}/`),
			},
			/** Багш */
			teacher: {
				get: (dep_id) => {
					var depId = ''
					if (dep_id) depId = dep_id
					return instance.get(`/core/teacher/?department=${depId}`)
				},
				getSelectSchool: (school) => instance.get(`/core/teacher/?school=${school}`),
				getList: (limit, page, sort, search, sub_org, salbar) => instance.get(`/core/teacher/list/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&sub_org=${sub_org}&salbar=${salbar}`),
				getOne: (pk) => instance.get(`/core/teacher/${pk}/`),
				getTeacherOne: (pk) => instance.get(`/core/reference/teachers/info/${pk}/`),

				/** Хичээлээс хамаарах багшийн жагсаалт */
				getTeacher: (lesson_id) => {
					var lesson = ''
					if (lesson_id) {
						lesson = lesson_id
					}
					return instance.get(`/core/teacher/lesson/?lesson=${lesson}`)
				},
				getLessonToTeacher: (lesson_id) => {
					var lesson = ''
					if (lesson_id) {
						lesson = lesson_id
					}
					return instance.get(`/core/teacher/lessonteach/?lesson=${lesson}`)
				},
			},
			/** Өрөө */
			room: {
				get: (room_type = "") =>
					instance.get(`/core/room/?room_type=${room_type}`),
			},
		},
		/** Чат */
		chat: {
			/** Чатлах боломжтой хэрэглэгч хайх */
			searchUser: (data) => instance.get(`/user/search/?name=${data}`),
			/** Тухайн чат өөрөөний дата авах */
			roomData: (user_id) => instance.get(`/chat/users/${user_id}/chats`),
			/** Тухайн хэрэглэгчтэй холоотой чат өрөөний мэдээллүүдийг авах нь */
			getRooms: () => instance.get("/chat/chats"),
			/** Check room */
			checkRoom: (data) => instance.post("/chat/chats", data),
			/** Чатьн дата авах */
			getChatData: (roomId, lastId) =>
				instance.get(
					`/chat/chats/${roomId}/messages/?lastId=${lastId}`
				),
		},

		/** Улирал */
		season: {
			get: () => instance.get(`/core/season/`),
			post: data => instance.post('/core/season/', data),
			getOne: (pk) => instance.get(`/core/season/${pk}/`),
			put: (data, pk) => instance.put(`/core/season/${pk}/`, data),
		},

		/** Дүнгийн үсгэн үнэлгээ */
		gradeletter: {
			get: () => instance.get(`/core/gradeletter/`)
		},

		/** Зар мэдээ */
		news: {
			get: (page, limit) =>
				instance.get(`lms/news/?page=${page}&limit=${limit}`),
			getOne: (pk) => instance.get(`lms/news/${pk}/`),
		},

		/** Өөрийгөө сорих тест */
		challenge: {
			get: (page, limit, lesson, type) =>
				instance.get(`teacher/challenge/?page=${page}&limit=${limit}&lesson=${lesson}&type=${type}`),

			getAll: (challenge) => {
				var c_challenge = ''
				if (challenge) c_challenge = challenge
				return instance.get(`teacher/challenge/all/?challenge=${c_challenge}`)
			},

			getSelect: (type, lesson) =>
				instance.get(`teacher/challenge/select/?type=${type}&year=${cyear_name}&season=${cseason_id}&lesson=${lesson}`),

			post: (data) =>
				instance.post(`teacher/challenge/?year=${cyear_name}&season=${cseason_id}`, data),

			getEditChallenge: (pk) => instance.get(`teacher/challenge/add/${pk}/`),
			postTest: (data) => instance.post(`teacher/challenge/add/`, data),
			putSelectedTest: (data, pk) => instance.put(`teacher/challenge/add/${pk}/`, data),
			putTest: (data) => instance.put(`teacher/challenge/add/student/`, data),
			putTestKind: (data, id) => instance.put(`teacher/challenge/add/student/addKind/${id}/?year=${cyear_name}&season=${cseason_id}`, data),
			getAddStudent: (page, limit, search,challenge) => instance.get(`teacher/challenge/add/student/?page=${page}&limit=${limit}&search=${search}&challenge=${challenge}`),
			deleteStudent: (id, challenge) => instance.delete(`teacher/challenge/add/student/delete/${id}/${challenge}/`),

			getSedev: (id) => instance.get(`teacher/challenge/add/sedev/?id=${id}`),
			getLevel: (id) => instance.get(`teacher/challenge/add/level/?id=${id}`),
			getCountQuestion: (id) => instance.get(`teacher/challenge/add/question/?id=${id}`),
			postSedevCount: (data) => instance.post(`teacher/challenge/add/sedev/count/`, data),
			deleteQuestion: (pk) => instance.delete(`teacher/challenge/add/sedev/count/${pk}/`),

			getStudents: (search) => instance.get(`teacher/challenge/student/?search=${search}`),

			put: (data, id) =>
				instance.put(`teacher/challenge/${id}/?year=${cyear_name}&season=${cseason_id}`, data),

			delete: (id) =>
				instance.delete(`teacher/challenge/${id}/`),

			send: (id) =>
				instance.get(`teacher/challenge/send/${id}/`),

			// ХБА шалгалт батлуулах хүсэлт
			getApprove: (page, limit, sort, search, type, teacherId, lessonId) =>
				instance.get(`teacher/challenge/approve/?page=${page}&limit=${limit}&type=${type}&sorting=${sort}&search=${search}&teacher=${teacherId}&lesson=${lessonId}`),

			postAnswer: (data) =>
				instance.post(`teacher/challenge/approve/`, data),

			//Шалгалт өгсөн хүүхдүүдийн дэлгэрэнгүй мэдээлэл
			getDetailOne: (pk) => instance.get(`teacher/challenge/details/one/${pk}`),
			getDetail: (page, limit, search, test_id) => instance.get(`teacher/challenge/details/?page=${page}&limit=${limit}&search=${search}&test_id=${test_id}`),

			question: {
				get: (page, limit, lessonId, subjectId, search) =>
					instance.get(`teacher/questions/?page=${page}&limit=${limit}&lesson=${lessonId}&subject=${subjectId}&search=${search}`),

				getOne: (page, limit, search, question_id) => instance.get(`teacher/questions/subject/?page=${page}&limit=${limit}&search=${search}&question_id=${question_id}`),

				getList: (checked_ids, count, type) => {
					var check_ids = ''
					for(var i of checked_ids) {
						check_ids += `&checked=${i}`
					}
					return instance.get(`teacher/questions/list/?count=${count}&type=${type}${check_ids}`)
				},

				post: (data) =>
					instance.post(`teacher/questions/?year=${cyear_name}&season=${cseason_id}`, data),

				put: (data, pk) =>
					instance.put(`teacher/questions/${pk}/?year=${cyear_name}&season=${cseason_id}`, data),

				delete: (delete_ids) =>
				{
					var remove_ids = ''
					for(var i of delete_ids) {
						remove_ids += `&delete=${i}`
					}
					return instance.delete(`teacher/questions/?year=${cyear_name}&season=${cseason_id}${remove_ids}`)
				}

			}
		},

		// Цагийн ачаалал
		credit: {
			volume: {
				get: (limit, page, sort, search, dep_id, year, teacherId) => instance.get(`lms/volume/?page=${page}&limit=${limit}&sorting=${sort}&search=${search}&department=${dep_id}&lesson_year=${year}&teacher=${teacherId}`),
				post: data => instance.post(`lms/volume/?lesson_year=${cyear_name}`, data),
				estimate: (dep_id, year)=> instance.post(`lms/volume/estimate/?dep_id=${dep_id}&schoolId=${school_id}&lesson_year=${year}`),
				getOne: (pk) => instance.get(`lms/volume/${pk}/`),
				put: (data, pk) => instance.put(`lms/volume/${pk}/`, data),
				delete: (pk) => instance.delete(`lms/volume/${pk}/`),
				printGet: (dep_id, year, teacherId) => instance.get(`lms/volume/print/?school=${school_id}&department=${dep_id}&lesson_year=${year}&teacher=${teacherId}`),
			},
			estimation: {
				get: () => instance.get(`lms/a_estimation/?lesson_year=${cyear_name}`),
				post: data => instance.post(`lms/a_estimation/?lesson_year=${cyear_name}`, data),

				// А цагийн тооцоо бодох
				estimate: (season) => instance.post(`lms/a_estimation/estimate/?season=${season}`),

				// Танхимийн бус цагийн төрөл авах
				getChamberType: (editId) => instance.get(`lms/a_estimation/chamber/?timeestimate=${editId}`),

				postChamber: (data) => instance.post(`lms/a_estimation/chamber/`, data),

				getOne: (pk) => instance.get(`lms/a_estimation/${pk}/`),
				put: (data, pk) => instance.put(`lms/a_estimation/${pk}/`, data),
				delete: (pk) => instance.delete(`lms/a_estimation/${pk}/`),
				printGet: (dep_id, year, teacherId) => instance.get(`lms/a_estimation/print/?school=${school_id}&department=${dep_id}&lesson_year=${year}&teacher=${teacherId}`),
			},
			// Цагийн багшийн тооцоо
			parttime: {
				get: (month) => instance.get(`lms/part-time/?month=${month}&year=${cyear_name}&season=${cseason_id}`),
			}
		},

		// ирц
		irts: {
			get: (timetableId) => instance.get(`/teacher/irts-list/${timetableId}/`),
			getStudents: (ttId) => instance.get(`/teacher/get-students-tt/${ttId}/`),
			changeState: (ttId, body) => instance.post(`/teacher/get-students-tt/${ttId}/`, body),
		},

		submitsurvey: {
			get: (page, limit, userId) => instance.get(`/teacher/submitsurvey/?page=${page}&limit=${limit}&id=${userId}`),
			post: (data) => instance.post(`/teacher/submitsurvey/`, data)
		},

		takesurvey:{
			get: (limit, page, selectedTime, search) => instance.get(`takesurvey/?limit=${limit}&page=${page}&time_type=${selectedTime}&search=${search}`),
			post: (cdatas) => instance.post('takesurvey/', cdatas),
			put: (data, pk) => instance.put(`takesurvey/${pk}/`, data),
			delete: (pk) => instance.delete(`takesurvey/${pk}/`),

			surveyrange:{
				// types болон selected_value дамжиж ирэх үед back-руу дамжуулна
				get: ({ limit='Бүгд', page=1, types='', selectedValue='' }) => instance.get(`takesurvey/surveyrange/?limit=${limit}&page=${page}&types=${types}&selected_value=${selectedValue}`),
			},

			results:{
				get: (searchValue) => instance.get(`/takesurvey/results/?search=${searchValue}`),
			},

			pollee:{
				get: (id) => instance.get(`/takesurvey/pollee/${id}/`)
			},

			soul: {
				getTimeTableLesson: ({ limit = 'Бүгд', page = 1, sort = '', search = '', department = '' }) => instance.get(`/takesurvey/timetable-lesson/?limit=${limit}&page=${page}&sorting=${sort}&search=${search}&department=${department}`),
				getTimeTableTeacher: ({ limit = 'Бүгд', page = 1, sort = '', search = '', department = '', lesson = '' }) => instance.get(`/takesurvey/timetable-teacher/?limit=${limit}&page=${page}&sorting=${sort}&search=${search}&department=${department}&lesson=${lesson}`),
			}

		},
		humanresource:{
			hr_attendance:{
				post: (cdata) => hr_instance.post(`/schedule/time-register-report-ajax/`, cdata)
			},
		},
		onlineLesson:{
			get: (lessonId) => instance.get(`/teacher/onlinelesson/?lesson=${lessonId}&year=${cyear_name}&season=${cseason_id}`),
			create:{
				post: (cdatas) => instance.post(`/teacher/onlinelesson/?year=${cyear_name}&season=${cseason_id}&school=${school_id}`, cdatas)
			},
			put: (pk, cdatas) => instance.put(`/teacher/onlinelesson/${pk}/`, cdatas),
			delete: (pk) => instance.delete(`/teacher/onlinelesson/${pk}/`)
		},

		/** оюутан */
		student: {
			// to get student info by student ID list
			getStudentsByList: ({ studentIds }) => instance.post(`/student/by-list/`, studentIds),
		}
	};
}

export default useApi;
